import {css} from 'emotion'
import { Colors, ProfileName, CardSmall } from './..'
import { Link } from '../typo';

export const RankingStyle = (ready) => css({
  '.filter-ranking, .ranking-position-go': {
    transition: 'opacity 400ms ease',
    opacity: ready ? 1 : 0,
  },
  '.ranking-user':{
    margin: '4rem auto',
    maxWidth: 800,
    '&-line': {
      justifyContent: 'center',
      padding: '0.5rem',

      '&.current': {
        border: '2px solid #000',
      }
    },
    '&-name, &-pos': {
      ...ProfileName,
      fontWeight: 'bold',
      color: 'black',
    },
    '&-name': {
      maxWidth: 'calc(1/2 * 100% - 60px)',
      flexBasis: 'calc(1/2 * 100% - 60px)',
    },
    '&-pos': {
     width: 60,
    },
    '&-localisation': {
      ...ProfileName,
      textTransform: 'uppercase',
      fontWeight: 'bold',
      color: Colors.lightGrey,
      maxWidth: 'calc(1/2 * 100% - 60px)',
      flexBasis: 'calc(1/2 * 100% - 60px)',
    },
    '&-score': {
      ...CardSmall,
      fontWeight: 'bold',
      color: Colors.red,
      width: 60,
      textAlign: 'right',
    }
  },
  '.ranking-position-go': {
    ...Link,
    position: 'fixed',
    bottom: 40,
    right: 40,
    background: 'transparent',
    border: 0,
    display: 'flex',

    '.label': {
      maxWidth: 100,
      flexBasis: 100,
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/ranking.js